import React from "react";
import { useHistory } from "react-router-dom";
import { type FormikFormChildProps } from "../FormikForm/FormikFormWrapperForJetpackConfig";
import KC_Heading2 from "../../../../designsystem/typography/KC-Heading/KC_Heading2";
import KC_Text from "../../../../designsystem/typography/KC_Text/KC_Text";
import { KC_Weights, KC_Text_Sizes } from "../../../../designsystem/ds_commons";
import { tt } from "../../../../utils/i18n/i18n";
import { configAnimation } from "../../../../utils/routes/routes";
import { buildPathWithTrackingId } from "../../../../utils/routing/routingUtils";
import { useAccountToDisplaySelector } from "../../../../redux/actions/user";
import KC_Padder from "../../../../designsystem/KC_Padder/KC_Padder";
import LandingCard from "./component/LandingCard";

const LoyaltyGiftsLanding = (_props: FormikFormChildProps) => {
  const history = useHistory();
  const { accountToDisplay } = useAccountToDisplaySelector();

  const goToTiers = () => {
    history.push(
      buildPathWithTrackingId(
        `${configAnimation}/prizes/gifts/tiers`,
        accountToDisplay?.trackingID
      )
    );
  };

  const goToLeaderboard = () => {
    history.push(
      buildPathWithTrackingId(
        `${configAnimation}/prizes/gifts/leaderboard`,
        accountToDisplay?.trackingID
      )
    );
  };

  return (
    <div className="d-flex flex-column main-gift-config dashboard-v2">
      <div className="px-4 pt-4 d-flex flex-column st-gap">
        <KC_Heading2 text={tt("loyalty_gifts_heading")} />
        <KC_Text
          size={KC_Text_Sizes.md}
          weight={KC_Weights.reg}
          text={tt("loyalty_prizes_section_description")}
          className="text-secondary"
        />
        <div className="w-100 p-0 m-0 st-gap gift-cards-container d-flex flex-row flex-wrap">
          <LandingCard
            titleKey="loyalty_gifts_configure_tiers"
            descriptionKey="loyalty_gifts_configure_tiers_desc"
            icon="⭐"
            onClick={goToTiers}
          />
          <LandingCard
            titleKey="loyalty_gifts_configure_leaderboard"
            descriptionKey="loyalty_leaderboard_special_prize_desc"
            icon="🏆"
            onClick={goToLeaderboard}
          />
        </div>
      </div>
      <KC_Padder />
    </div>
  );
};

export default LoyaltyGiftsLanding;
